import React, { useState, useRef, useEffect, useCallback } from "react";
import {
  Box,
  VStack,
  HStack,
  Text,
  Divider,
  ScrollView,
  Pressable,
  Button,
  View,
  Image,
  FlatList,
  Input,
  CloseIcon,
} from "native-base";
import { Loc } from "../../App/Loc";
import { Dimensions } from "react-native";
import AVCancel from "../../components/common/AVCancel";
import AVInputtext from "../../components/AVInputtext";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select, { SelectChangeEvent } from "@mui/material/Select";
import {
  AddIcon,
  CrossIcon,
  SearchIcon,
  Profile,
  XIconRounded,
} from "../../assets/icons/icon-assets";
import { useNavigate, useParams } from "react-router-dom";
import EntityProfilePic from "../../components/common/EntityProfilePic";
import * as AV from "../../AVCore/AVCore";
import { useDispatch, useSelector, RootStateOrAny } from "react-redux";
import _ from "lodash";
import { Link } from "../../AVCore/Link";
import { setEntitydata, setSearch } from "../../Redux/Actions/userActions";
import inform from "../../assets/images/inform.png";
import { Club } from "../../AVCore/Club";
import {
  FacebookShareButton,
  FacebookIcon,
  EmailShareButton,
  EmailIcon,
  WhatsappShareButton,
  WhatsappIcon,
  LinkedinShareButton,
  LinkedinIcon,
  TwitterShareButton,
  TwitterIcon,
  PinterestShareButton,
  PinterestIcon,
  TelegramShareButton,
  TelegramIcon,
  TumblrShareButton,
  TumblrIcon,
} from "react-share";
import "driver.js/dist/driver.css";
import { driver } from "driver.js";

type AVPersonaModalProps = {
  seriesEvent?: any;
  isMember?: boolean;
  setShowAddProfileModal?: any;
  isStaff?: boolean;
  Entity?: any;
  setEntity?: any;
  setcontactList?: any;
  setshowFileuploadModal?: any;
  setStaffList?: any;
  setmemberList?: any;
  isPlayer?: boolean;
  setPlayersList?: any;
  isParticipant?: boolean;
  showAddProfileModal?: boolean;
  isTeam?: boolean;
  searchTypes?: any;
  setOrgList?: any;
  setGroupList?: any;
  isEditEntireSeries?: boolean;
  isSchoolTeamsPage?: boolean;
  setSchoolTeamsList?: any;

  onboardingFlow?: string | null;
  onboardingStep?: number;
  setOnboardingStep?: React.Dispatch<React.SetStateAction<number>>;
  clearCurrentTourFlow?: () => void;
};

const AVPersonaModal = ({
  seriesEvent,
  isMember,
  setShowAddProfileModal,
  isStaff,
  Entity,
  setEntity,
  setcontactList,
  setshowFileuploadModal,
  setStaffList,
  setmemberList,
  isPlayer,
  setPlayersList,
  isParticipant,
  showAddProfileModal,
  isTeam,
  searchTypes,
  setOrgList,
  setGroupList,
  isEditEntireSeries,
  isSchoolTeamsPage = false,
  onboardingFlow = null,
  onboardingStep = 0,
  setOnboardingStep = () => {},
  clearCurrentTourFlow,
}: AVPersonaModalProps) => {
  const navigate = useNavigate();
  const params = useParams();
  const seriesId: any =
    params?.seriesId !== "undefined" && params?.seriesId !== undefined
      ? params?.seriesId
      : null;
  const dispatch = useDispatch();
  const dimensions = Dimensions.get("window");
  const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
  const phoneRegex = /^(\+\d{1,3}[- ]?)?\d{10}$/;
  const isMobile = dimensions?.width <= 600 || false;
  const isLMobile = dimensions?.width <= 780 || false;
  const [checkvalue, setcheckvalue] = useState(true);
  const [checkvaluedata, setcheckvaluedata] = useState<any>("");
  const [filteredResults, setfilteredResults] = useState([]);
  const [name, setName] = useState("");
  const [emailAddress, setIsEmailaddress] = useState("");
  const [phone, setPhone] = useState("");
  const [Parentname, setParentName] = useState("");
  const [ParentemailAddress, setIsParentEmailaddress] = useState("");
  const [Parentphone, setParentPhone] = useState("");
  const [Role, setRole] = useState("");
  const [showTempList, setshowTempList] = useState<AV.ILink[]>([]);
  const imageInputRef = useRef<HTMLInputElement>(null);
  const [error, setError] = useState("");
  const [isValid, setIsValid] = useState(true);
  const [isLoader, setIsLoader] = useState(false);
  const localUserSearch = useSelector(
    (state: RootStateOrAny) => state.user.userSearch,
  );
  const [guardianLocalFilteredResults, setGuardianLocalFilteredResults] =
    useState([]);
  const [showSearch, setShowSearch] = useState(false);
  const [searchInput, setSearchInput] = useState("");
  const [GuardianFilteredResults, setGuardianFilteredResults] = useState([]);
  const [searchYearStudents, setSearchYearStudents] = useState(false);
  const [schoolYearStudents, setSchoolYearStudents] = useState<AV.ILink[]>([]);
  const [searchCollectMembers, setSearchCollectMembers] = useState(false);
  const [collectEntityStaffs, setCollectEntityStaffs] = useState<AV.ILink[]>(
    [],
  );
  const [collectEntityMembers, setCollectEntityMembers] = useState<AV.ILink[]>(
    [],
  );
  const entitydatalist = useSelector(
    (state: RootStateOrAny) => state.user.entitydatalist,
  );
  const [teamsList, setTeamsList] = useState<any>([]);
  const currentUser = useSelector(
    (state: RootStateOrAny) => state?.user?.user[0],
  );
  const [errorMessage, setErrorMessage] = useState("");
  const [isSearchDone, setSearchDone] = useState(true);

  const customSelectStyle = {
    maxHeight: "50px", // Set your desired height here
    width: "100%",
  };

  const customSelectStyleeee = {
    maxHeight: "50px", // Set your desired height here
  };

  const socialInviteRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    if (!showAddProfileModal || !socialInviteRef.current) return;
    if (!onboardingFlow) return;

    const tour = driver({
      showProgress: false,
      allowClose: true,
      overlayClickBehavior: () => {},
      showButtons: [],
      onCloseClick: () => {
        tour.destroy();
        clearCurrentTourFlow?.();
      },
      steps: [
        {
          element: socialInviteRef.current,
          popover: {
            title:
              onboardingFlow === "teamMember" ||
              onboardingFlow === "clubMember" ||
              onboardingFlow === "eliteClubMember" ||
              onboardingFlow === "schoolStaff"
                ? Loc.currentLang.inviteTourGuide.step4_4
                : onboardingFlow === "teamSeasonPlayer" ||
                    onboardingFlow === "performancePlayer" ||
                    onboardingFlow === "clubTermMember" ||
                    onboardingFlow === "schoolYearStudent" ||
                    onboardingFlow === "groupMember" ||
                    onboardingFlow === "classStudent" ||
                    onboardingFlow === "gradClassStudent" ||
                    onboardingFlow === "organizationEmployee" ||
                    onboardingFlow === "neighborhoodNeighbors" ||
                    onboardingFlow === "communityMember"
                  ? Loc.currentLang.inviteTourGuide.step3_3
                  : "Invite",
            description: `${Loc.currentLang.inviteTourGuide.inviteInstantly} ${
              onboardingFlow === "teamMember" ||
              onboardingFlow === "clubMember" ||
              onboardingFlow === "clubTermMember" ||
              onboardingFlow === "eliteClubMember" ||
              onboardingFlow === "groupMember" ||
              onboardingFlow === "communityMember"
                ? Loc.currentLang.inviteTourGuide.members
                : onboardingFlow === "teamSeasonPlayer" ||
                    onboardingFlow === "performancePlayer" ||
                    onboardingFlow === "clubTermMember"
                  ? Loc.currentLang.inviteTourGuide.players
                  : onboardingFlow === "schoolStaff"
                    ? Loc.currentLang.inviteTourGuide.staff
                    : onboardingFlow === "schoolYearStudent" ||
                        onboardingFlow === "classStudent" ||
                        onboardingFlow === "gradClassStudent"
                      ? Loc.currentLang.inviteTourGuide.students
                      : onboardingFlow === "organizationEmployee"
                        ? Loc.currentLang.inviteTourGuide.employees
                        : onboardingFlow === "neighborhoodNeighbors"
                          ? Loc.currentLang.inviteTourGuide.neighbors
                          : "Invite"
            } ${Loc.currentLang.inviteTourGuide.inviteInstantlyEnd}`,
            side: "top",
            align: "center",
          },
        },
      ],
      onPopoverRender: (popover) => {
        const footer = popover.wrapper.querySelector(
          ".driver-popover-footer",
        ) as HTMLElement;
        if (!footer) return;

        footer.innerHTML = "";
        footer.style.display = "flex";
        footer.style.justifyContent = "flex-end";
        footer.style.gap = "8px";

        const finish = document.createElement("button");
        finish.innerText = Loc.currentLang.inviteTourGuide.finish;
        finish.className = "tour-btn-primary";
        finish.onclick = () => {
          tour.destroy();
          clearCurrentTourFlow?.();
        };

        footer.append(finish);
      },
    });

    setTimeout(() => tour.drive(), 100);
  }, [onboardingFlow, onboardingStep]);

  const handleStaffName = (item) => {
    setName(item.title);
    setcheckvaluedata(item);
    setcheckvalue(false);
    setfilteredResults([]);
  };

  const handlefileUpload = async (e: any) => {
    setError("");
    const fileInput: any = imageInputRef.current;
    let files = Array.from(e?.target?.files);
    // Check file extensions
    const allowedExtensions = ["docx", "xlsx", "ods", "odt", "csv", "txt"];
    const validFiles: any = files.filter((file: any) => {
      const fileExtension = file.name.split(".").pop().toLowerCase();
      return allowedExtensions.includes(fileExtension);
    });

    if (validFiles.length === 0) {
      setError(Loc.currentLang.menu.invaildFileMsg);
      return;
    }

    let val = AV.Media.getFormData(validFiles);
    let contact = await AV.AVEntity.fileContacts(val, isPlayer ? true : false);
    if (contact?.length > 0) {
      setcontactList(contact);
      setshowFileuploadModal(true);
    }

    if (contact?.length === 0) {
      setError("Need data for Name,Email and Role");
    }
    fileInput.value = null;
  };

  const HandleEmailAddress = (e) => {
    e.preventDefault();
    setIsEmailaddress(e.target.value);

    if (emailRegex.test(emailAddress)) {
      setIsValid(true);
    } else {
      setIsValid(false);
    }
  };

  const HandlePhone = (e) => {
    e.preventDefault();
    setPhone(e.target.value.replace(/[^0-9]/g, ""));

    if (phoneRegex.test(e.target.value)) {
      setIsValid(true);
    } else {
      setIsValid(false);
    }
  };

  const handleDrop = async (e) => {
    e.preventDefault();

    const doc = e.dataTransfer.files;
    const fileInput: any = imageInputRef.current;
    let files: any = Array.from(doc);
    // Check file extensions
    const allowedExtensions = ["docx", "xlsx", "ods", "odt", "csv", "txt"];
    const validFiles: any = files.filter((file: any) => {
      const fileExtension = file.name.split(".").pop().toLowerCase();
      return allowedExtensions.includes(fileExtension);
    });

    if (validFiles.length === 0) {
      setError(Loc.currentLang.menu.invaildFileMsg);
      return;
    }

    let val = AV.Media.getFormData(validFiles);
    let contact = await AV.AVEntity.fileContacts(val, isPlayer ? true : false);
    if (contact?.length > 0) {
      setcontactList(contact);
      setshowFileuploadModal(true);
    }

    if (contact?.length === 0) {
      setError("Need data for Name,Email and Role");
    }
    fileInput.value = null;
  };

  const handleDragOver = (e) => {
    e.preventDefault();
  };

  const HandleParentPhone = (e) => {
    e.preventDefault();
    setParentPhone(e.target.value.replace(/[^0-9]/g, ""));
    if (phoneRegex.test(e.target.value)) {
      setIsValid(true);
    } else {
      setIsValid(false);
    }
  };

  const handleAddTeamProfile = async () => {
    setIsLoader(true);

    if (!checkvalue) {
      let cacheEntity = entitydatalist?.find(
        (x) => x?.id === checkvaluedata?.id,
      );

      if (!cacheEntity?.id) {
        const entityValue = await AV.AVEntity.get(
          AV.AVEntity.getFk(checkvaluedata),
        );

        if (entityValue) {
          const updatedEntityData = [...(entitydatalist || []), entityValue];
          dispatch(setEntitydata(updatedEntityData));
          cacheEntity = entityValue;
        }
      }

      if (
        cacheEntity?.parent
          ?.id /* && cacheEntity?.parent?.type !== "LeagueSeason"*/
      ) {
        setErrorMessage(Loc.currentLang.menu.childOrgValidation);
        setIsLoader(false);
        return;
      }

      if (
        cacheEntity?.staff?.filter((x) => x?.id == currentUser?.id)?.length >
        0 /* || Entity?.type === "LeagueSeason"*/
      ) {
        let team: any = await Club.addTeam(
          AV.AVEntity.getFk(Entity),
          checkvaluedata,
        );
        teamsList.unshift(checkvaluedata);
        if (searchTypes == "Group" && team?.childOrgs?.length > 0) {
          setGroupList(team?.childOrgs?.filter((x: any) => x?.type == "Group"));
          entitydatalist[
            entitydatalist.indexOf(
              entitydatalist?.find((x) => x?.id === team?.id),
            )
          ] = team;
          dispatch(setEntitydata(entitydatalist));
        } else {
          if (team?.childOrgs?.length > 0) {
            setOrgList(team?.childOrgs);
            //setEntity?.(team);
            entitydatalist[
              entitydatalist.indexOf(
                entitydatalist?.find((x) => x?.id === team?.id),
              )
            ] = team;
            dispatch(setEntitydata(entitydatalist));
          }
        }

        setSearchInput("");
        setcheckvalue(true);
        setcheckvaluedata("");
        setShowAddProfileModal(false);
      } else {
        setErrorMessage(Loc.currentLang.menu.youAreNotAnStaffOfThisEntity);
        setIsLoader(false);
        return;
      }
    }

    setIsLoader(false);
  };

  function ValidateStaffs() {
    if (emailAddress !== "" || ParentemailAddress !== "") {
      return true;
    }
  }

  const menuRefs = useRef(null);
  useOutsideAlerter(menuRefs);
  function useOutsideAlerter(ref) {
    useEffect(() => {
      function handleClickOutside(event) {
        if (ref.current && !ref.current.contains(event.target)) {
          setShowSearch(false);
        }
      }
      document.addEventListener("mousedown", handleClickOutside);
      return () => {
        document.removeEventListener("mousedown", handleClickOutside);
      };
    }, [ref]);
  }

  const handleAddProfile = async (type) => {
    setIsLoader(true);

    // Selected student must belong to the school year
    if (searchYearStudents) {
      if (!schoolYearStudents?.find((x) => x?.id === checkvaluedata.id)) {
        setErrorMessage(Loc.currentLang.menu.yearStudentValidation);
        setIsLoader(false);
        return;
      }
    }

    // Selected member must belong to the parent entity's member list
    if (searchCollectMembers) {
      if (collectEntityStaffs?.find((x) => x?.id === checkvaluedata.id)) {
        setErrorMessage(Loc.currentLang.feeCollect.ownerFeeValidation);
        setIsLoader(false);
        return;
      }

      if (!collectEntityMembers?.find((x) => x?.id === checkvaluedata.id)) {
        setErrorMessage(Loc.currentLang.feeCollect.memberValidation);
        setIsLoader(false);
        return;
      }
    }

    // Staff cannot be added if already a member
    if (isStaff && Entity?.members?.some((x) => x?.id === checkvaluedata.id)) {
      setErrorMessage(Loc.currentLang.menu.alreadyMemberError);
      setIsLoader(false);
      return;
    }

    // Member cannot be added if already a staff
    if (isMember && Entity?.staff?.some((x) => x?.id === checkvaluedata.id)) {
      setErrorMessage(Loc.currentLang.menu.alreadyStaffError);
      setIsLoader(false);
      return;
    }

    // Member cannot be added if already a participants
    if (
      searchCollectMembers &&
      Entity?.participants?.some((x) => x?.id === checkvaluedata.id)
    ) {
      setErrorMessage(Loc.currentLang.menu.alreadyMemberError);
      setIsLoader(false);
      return;
    }

    if (
      type === "Staff" &&
      ValidateStaffs() &&
      emailRegex.test(emailAddress) &&
      checkvalue
    ) {
      setErrorMessage("");
      let coach: any = { name: Role, rights: { canUpdate: true } };
      let addstaff: any = await AV.OrgBase.addStaff(AV.AVEntity.getFk(Entity), {
        name: name,
        email: emailAddress,
        phone: phone,
        role: coach,
      });

      if (addstaff !== null) {
        setEntity(addstaff);

        if (
          entitydatalist?.filter((x: any) => x?.id === addstaff?.id)?.length > 0
        ) {
          entitydatalist[
            entitydatalist.indexOf(
              entitydatalist?.find((x: any) => x?.id === addstaff?.id),
            )
          ] = addstaff;
          dispatch(setEntitydata(entitydatalist));
        }

        setStaffList(addstaff?.staff);
        let tempstaff: any = showTempList;
        tempstaff.push(addstaff?.staff[addstaff?.staff?.length - 1]);
        setshowTempList(tempstaff);
      }

      setName("");
      setIsEmailaddress("");
      setPhone("");
      setRole("");
      setIsLoader(false);
      setcheckvalue(false);
    } else if (type === "Staff" && !checkvalue) {
      setErrorMessage("");
      let coach: any = { name: Role, rights: { canUpdate: true } };
      let addStaff: any = await AV.OrgBase.addStaff(AV.AVEntity.getFk(Entity), {
        name: name,
        email: emailAddress,
        id: checkvaluedata.id,
        pk: checkvaluedata.pk,
        type: checkvaluedata.type,
        region: checkvaluedata.region,
        phone: phone,
        role: coach,
      });

      if (addStaff !== null) {
        setEntity(addStaff);

        if (
          entitydatalist?.filter((x: any) => x?.id === addStaff?.id)?.length > 0
        ) {
          entitydatalist[
            entitydatalist.indexOf(
              entitydatalist?.find((x: any) => x?.id === addStaff?.id),
            )
          ] = addStaff;
          dispatch(setEntitydata(entitydatalist));
        }

        setStaffList(addStaff?.staff);
        let tempstaff: any = showTempList;
        tempstaff.push(addStaff?.staff[addStaff?.staff?.length - 1]);
        setshowTempList(tempstaff);
      }

      setName("");
      setIsEmailaddress("");
      setPhone("");
      setRole("");
      setIsLoader(false);
      setcheckvalue(false);
    }

    if (
      type == "Member" &&
      ValidateStaffs() &&
      emailRegex.test(emailAddress) &&
      checkvalue
    ) {
      setErrorMessage("");
      let addMember: any = await AV.OrgBase.addMember(
        AV.AVEntity.getFk(Entity),
        {
          name: name,
          email: emailAddress,
          phone: phone,
        },
      );

      if (addMember !== null) {
        setEntity(addMember);
        setmemberList?.(addMember?.members);
        let tempstaff: any = showTempList;
        tempstaff.push(addMember?.members[addMember?.members?.length - 1]);
        setshowTempList(tempstaff);
      }

      setName("");
      setIsEmailaddress("");
      setPhone("");
      setRole("");
      setIsLoader(false);
      setcheckvalue(false);
    } else if (type == "Member" && !checkvalue && !searchCollectMembers) {
      setErrorMessage("");
      let addMember: any = await AV.OrgBase.addMember(
        AV.AVEntity.getFk(Entity),
        {
          name: name,
          email: emailAddress,
          id: checkvaluedata.id,
          pk: checkvaluedata.pk,
          type: checkvaluedata.type,
          region: checkvaluedata.region,
          phone: phone,
        },
      );

      if (addMember !== null) {
        setEntity(addMember);
        setmemberList?.(addMember?.members);
        let tempstaff: any = showTempList;
        tempstaff.push(addMember?.members[addMember?.members?.length - 1]);
        setshowTempList(tempstaff);
      }

      setName("");
      setcheckvalue(true);
    } else if (type == "Member" && !checkvalue && searchCollectMembers) {
      setErrorMessage("");
      const addMember = await AV.Collect.addParticipant(
        AV.AVEntity.getFk(Entity),
        {
          title: name,
          id: checkvaluedata.id,
          pk: checkvaluedata.pk,
          type: checkvaluedata.type,
          thumb: checkvaluedata.thumb,
          region: checkvaluedata.region,
        },
      );

      if (addMember !== null) {
        setEntity(addMember);
        const lastMember =
          addMember?.participants?.[addMember.participants.length - 1];

        if (lastMember) {
          let tempstaff = [...showTempList];
          tempstaff.push(lastMember);
          setshowTempList(tempstaff);
        }
      }

      setName("");
      setcheckvalue(true);
    }

    if (
      type == "Player" &&
      ValidateStaffs() &&
      emailRegex.test(
        emailAddress?.trim()?.length > 0 ? emailAddress : ParentemailAddress,
      ) &&
      checkvalue
    ) {
      setErrorMessage("");
      let newPlayer: any = {
        parentName: Parentname?.trim()?.length > 0 ? Parentname : null,
        parentEmail:
          ParentemailAddress?.trim()?.length > 0 ? ParentemailAddress : null,
        parentPhone: Parentphone?.trim()?.length > 0 ? Parentphone : null,
        name: name,
        email: emailAddress,
        phone: phone,
      };

      let addplayr: any = await AV.Team.addPlayer(
        AV.AVEntity.getFk(Entity),
        newPlayer,
      );
      if (addplayr != null) {
        setEntity(addplayr);
        setPlayersList(addplayr?.players);
        setmemberList?.(addplayr?.members);
        let tempstaff: any = showTempList;
        tempstaff.push(addplayr?.players[addplayr?.players?.length - 1]);
        setshowTempList(tempstaff);
      }

      setName("");
      setIsEmailaddress("");
      setPhone("");
      setParentName("");
      setIsParentEmailaddress("");
      setParentPhone("");
      setcheckvalue(false);
    } else if (type == "Player" && !checkvalue) {
      setErrorMessage("");
      if (Entity?.subType === "Class" || Entity?.subType === "GradClass") {
        if (Entity?.members?.some((x) => x.id === checkvaluedata.id)) {
          setErrorMessage(Loc.currentLang.menu.childOrgValidation);
          setIsLoader(false);
          return;
        }
      }

      let addplayer: any = await AV.Team.addPlayer(AV.AVEntity.getFk(Entity), {
        name: name,
        id: checkvaluedata.id,
        pk: checkvaluedata.pk,
        type: checkvaluedata.type,
        region: checkvaluedata.region,
        email: emailAddress,
        phone: phone,
        parentName: Parentname?.trim()?.length > 0 ? Parentname : undefined,
        parentEmail:
          ParentemailAddress?.trim()?.length > 0
            ? ParentemailAddress
            : undefined,
        parentPhone: Parentphone?.trim()?.length > 0 ? Parentphone : undefined,
      });

      if (addplayer?.id) {
        if (
          entitydatalist?.filter((x: any) => x?.id === addplayer?.id)?.length >
          0
        ) {
          entitydatalist[
            entitydatalist.indexOf(
              entitydatalist?.find((x: any) => x?.id === addplayer?.id),
            )
          ] = addplayer;
          dispatch(setEntitydata(entitydatalist));
        }

        setEntity(addplayer);
        setPlayersList(addplayer?.players);
        setmemberList?.(addplayer?.members);
        let tempstaff: any = showTempList;
        tempstaff.push(addplayer?.players[addplayer?.players?.length - 1]);
        setshowTempList(tempstaff);
      }

      setName("");
      setIsEmailaddress("");
      setPhone("");
      setParentName("");
      setIsParentEmailaddress("");
      setParentPhone("");
      setcheckvalue(false);
    }

    if (
      type == "Participant" &&
      ValidateStaffs() &&
      emailRegex.test(emailAddress) &&
      checkvalue
    ) {
      console.log("Entered into the 1 st If Condition::::");
      let occurId =
        !isEditEntireSeries &&
        Entity.series?.trim()?.length > 0 &&
        seriesId?.trim()?.length > 0 &&
        seriesId
          ? seriesId
          : null;
      let addpartcipants: any = await AV.Event.addParticipant(
        AV.AVEntity.getFk(Entity),
        {
          name: name,
          email: emailAddress,
          phone: phone,
          //position: 'QB',
        },
        occurId,
      );

      if (occurId !== null) {
        let seriesEvent = addpartcipants?.seriesEvents.find(
          (x) => x.id == occurId,
        );
        let AllParticipant = [
          ...seriesEvent?.participants,
          ...addpartcipants?.participants,
        ];
        AllParticipant = _.uniqBy(AllParticipant, "id");
        setPlayersList(AllParticipant);
        let tempstaff: any = showTempList;
        tempstaff.push(
          seriesEvent?.participants[seriesEvent?.participants?.length - 1],
        );
        setshowTempList(tempstaff);
        setEntity(addpartcipants);
        entitydatalist[
          entitydatalist.indexOf(
            entitydatalist?.find((x) => x?.id === addpartcipants?.id),
          )
        ] = addpartcipants;
        dispatch(setEntitydata(entitydatalist));
      } else {
        setEntity(addpartcipants);
        setPlayersList(addpartcipants?.participants);
        let tempstaff: any = showTempList;
        tempstaff.push(
          addpartcipants?.participants[
            addpartcipants?.participants?.length - 1
          ],
        );
        setshowTempList(tempstaff);
        entitydatalist[
          entitydatalist.indexOf(
            entitydatalist?.find((x) => x?.id === addpartcipants?.id),
          )
        ] = addpartcipants;
        dispatch(setEntitydata(entitydatalist));
      }

      setName("");
      setIsEmailaddress("");
      setPhone("");
    } else if (type == "Participant" && !checkvalue) {
      let occurId =
        !isEditEntireSeries &&
        Entity.series?.trim()?.length > 0 &&
        seriesId?.trim()?.length > 0 &&
        seriesId
          ? seriesId
          : null;
      let addpartcipants: any;

      if (occurId !== null) {
        let fk = {
          id: Entity.series,
          fk: Entity.series.slice(-4),
          region: Entity.region,
          type: Entity.type,
        };
        addpartcipants = await AV.Event.addParticipant(
          AV.AVEntity.getFk(fk),
          {
            thumb: checkvaluedata?.thumb,
            title: name,
            id: checkvaluedata.id,
            pk: checkvaluedata.pk,
            type: checkvaluedata.type,
            region: checkvaluedata.region,
            email: emailAddress,
            phone: phone,
          },
          occurId,
        );
      } else {
        let occurId = null;
        addpartcipants = await AV.Event.addParticipant(
          AV.AVEntity.getFk(Entity),
          {
            thumb: checkvaluedata?.thumb,
            title: name,
            id: checkvaluedata.id,
            pk: checkvaluedata.pk,
            type: checkvaluedata.type,
            region: checkvaluedata.region,
            email: emailAddress,
            phone: phone,
          },
          occurId,
        );
      }

      if (occurId !== null) {
        let seriesEvent = addpartcipants?.seriesEvents.find(
          (x) => x.id == occurId,
        );
        let AllParticipant = [
          ...seriesEvent?.participants,
          ...addpartcipants?.participants,
        ];
        AllParticipant = _.uniqBy(AllParticipant, "id");

        // To sort the array so that items with linkType === 'Owner' or linkType === 'Staff' come first
        AllParticipant = AllParticipant?.sort((a, b) => {
          const getRank = (type) => {
            if (type === "Owner") return 0;
            if (type === "Staff") return 1;
            return 2; // for Participant or any other
          };
          return getRank(a.linkType) - getRank(b.linkType);
        });

        setPlayersList(AllParticipant);
        let tempstaff: any = showTempList;
        tempstaff.push(
          seriesEvent?.participants[seriesEvent?.participants?.length - 1],
        );
        setshowTempList(tempstaff);
        setEntity(addpartcipants);
        entitydatalist[
          entitydatalist.indexOf(
            entitydatalist?.find((x) => x?.id === addpartcipants?.id),
          )
        ] = addpartcipants;
        dispatch(setEntitydata(entitydatalist));
      } else {
        setEntity(addpartcipants);
        setPlayersList(addpartcipants?.participants);
        let tempstaff: any = showTempList;
        tempstaff.push(
          addpartcipants?.participants[
            addpartcipants?.participants?.length - 1
          ],
        );
        setshowTempList(tempstaff);

        if (addpartcipants.seriesEvents?.some((x) => x.id === seriesId)) {
          const seriesParticipants =
            addpartcipants.seriesEvents.find((x) => x.id === seriesId)
              ?.participants || [];
          let allParticipants = [
            ...addpartcipants.participants,
            ...seriesParticipants,
          ];

          // To sort the array so that items with linkType === 'Owner' or linkType === 'Staff' come first
          allParticipants = allParticipants?.sort((a, b) => {
            const getRank = (type) => {
              if (type === "Owner") return 0;
              if (type === "Staff") return 1;
              return 2; // for Participant or any other
            };
            return getRank(a.linkType) - getRank(b.linkType);
          });
        }

        entitydatalist[
          entitydatalist.indexOf(
            entitydatalist?.find((x) => x?.id === addpartcipants?.id),
          )
        ] = addpartcipants;
        dispatch(setEntitydata(entitydatalist));
      }

      setName("");
      setIsEmailaddress("");
      setPhone("");
      setcheckvalue(true);
    } else if (
      (emailAddress && !emailRegex.test(emailAddress)) ||
      (ParentemailAddress && !emailRegex.test(ParentemailAddress))
    ) {
      setErrorMessage(Loc.currentLang.menu.inValiedEmail);
      setIsLoader(false);
      return;
    }

    setIsLoader(false);
    setcheckvalue(true);
    setErrorMessage("");
  };

  const SocialShare = () => {
    const [shareUrl, setShareUrl] = useState(window.location.origin);

    useEffect(() => {
      const generateUrl = async () => {
        let contact: AV.ITokenProcessRequest = {
          type: isStaff ? "AddStaff" : isPlayer ? "AddPlayer" : "Add",
          entity: AV.AVEntity.getLink(Entity),
        };
        let val: any = await AV.AVEntity.createTokenRequest(contact);
        if (val?.token) {
          const url = `${window.location.origin}/Link/${val.type}/${val.token}`;
          console.log("ShareURL:", url);
          setShareUrl(url);
        }
      };
      if (Entity) {
        generateUrl();
      }
    }, [Entity]);

    const title = Loc.currentLang.post.inviteMessage;
    const body = Loc.currentLang.post.inviteMessage;
    const media =
      "https://play-lh.googleusercontent.com/gw09xDUsyBktV2HqNlBHf6xE7ICjlRwWBqi0vZ7IqQ2pRJVSVqF6nPuTcX9d5_Hmvw";

    return (
      <HStack
        alignItems="center"
        space={5}
        justifyContent="center"
        flexWrap="wrap"
        width={isMobile ? "80%" : isLMobile ? "80%" : ""}
      >
        {/*{shareUrl && shareUrl !== window.location.origin && (*/}
        {/*  <>*/}
        <WhatsappShareButton url={shareUrl} title={title} separator=":: ">
          <WhatsappIcon size={35} round />
        </WhatsappShareButton>

        <FacebookShareButton url={shareUrl} quote={title}>
          <FacebookIcon size={35} round />
        </FacebookShareButton>

        <LinkedinShareButton
          url={shareUrl}
          title={title}
          summary={title}
          source={title}
        >
          <LinkedinIcon size={35} round />
        </LinkedinShareButton>

        <TwitterShareButton url={shareUrl} title={title}>
          <XIconRounded />
        </TwitterShareButton>

        <EmailShareButton
          url={shareUrl}
          subject={title}
          body={body}
          separator=": "
        >
          <EmailIcon size={35} round />
        </EmailShareButton>

        <PinterestShareButton
          url={shareUrl}
          media={media}
          description="description of the image"
        >
          <PinterestIcon size={35} round />
        </PinterestShareButton>

        <TelegramShareButton url={shareUrl} title={title}>
          <TelegramIcon size={35} round />
        </TelegramShareButton>

        <TumblrShareButton url={shareUrl} title={title}>
          <TumblrIcon size={35} round />
        </TumblrShareButton>
        {/*  </>*/}
        {/*)}*/}
      </HStack>
    );
  };

  const handlesearchTeams = async (e) => {
    setSearchDone(true);

    if (!isTeam) {
      let localsearch = await AV.Person.localSearch(e);
      let locallySearch = localUserSearch;
      if (locallySearch == undefined) {
        locallySearch = [];
      }
      locallySearch = locallySearch.concat(localsearch);
      locallySearch = _.uniqBy(locallySearch, "id");
      locallySearch = locallySearch?.filter((x) => x?.type == "Person");
      locallySearch = locallySearch?.filter(
        (x) =>
          x?.title !== undefined &&
          x?.title?.toLocaleLowerCase().includes(e.toLocaleLowerCase()),
      );

      if (isStaff || isMember) {
        locallySearch = locallySearch?.filter(
          (item1) =>
            !Entity?.staff?.some((item2) => item2?.id === item1?.id) &&
            !Entity?.members?.some((item2) => item2?.id === item1?.id),
        );
      } else if (isParticipant) {
        let occurId =
          !isEditEntireSeries &&
          Entity.series?.trim()?.length > 0 &&
          seriesId?.trim()?.length > 0 &&
          seriesId
            ? seriesId
            : null;

        if (occurId) {
          locallySearch = locallySearch?.filter(
            (item1) =>
              !Entity?.participants?.some((item2) => item2?.id === item1?.id),
          );
          let occurEntity = Entity?.seriesEvents?.filter(
            (x) => x.id === occurId,
          );

          if (occurEntity?.length > 0) {
            locallySearch = locallySearch?.filter(
              (item1) =>
                !occurEntity[0]?.participants?.some(
                  (item2) => item2?.id === item1?.id,
                ),
            );
          }
        } else {
          locallySearch = locallySearch?.filter(
            (item1) =>
              !Entity?.participants?.some((item2) => item2?.id === item1?.id),
          );
        }
      } else {
        locallySearch = locallySearch?.filter(
          (item1) => !Entity?.players?.some((item2) => item2?.id === item1?.id),
        );
      }

      locallySearch = locallySearch?.filter(
        (item1) =>
          !currentUser?.blocked?.some((item2) => item2?.id === item1?.id),
      );

      if (searchYearStudents) {
        locallySearch = locallySearch?.filter((item1) =>
          schoolYearStudents?.some((item2) => item2?.id === item1?.id),
        );
      }

      if (searchCollectMembers) {
        locallySearch = locallySearch?.filter((item1) =>
          collectEntityMembers?.some((item2) => item2?.id === item1?.id),
        );
      }

      setGuardianLocalFilteredResults(
        locallySearch?.filter((x) => x?.type === "Person"),
      );
      setShowSearch(true);
      setSearchInput(e);
      setName(e);
    } else {
      setErrorMessage("");
      let localsearch = currentUser?.orgs;
      localsearch = localsearch.concat(localUserSearch);
      localsearch = localsearch?.filter(
        (x) =>
          x?.title !== undefined &&
          x?.title?.toLocaleLowerCase().includes(e.toLocaleLowerCase()),
      );

      if (searchTypes == "Group" || searchTypes == "SubGroup") {
        setGuardianLocalFilteredResults(
          localsearch?.filter(
            (x) => x?.type === "Group" && x?.subType == undefined,
          ),
        );
      } else if (searchTypes == "Organization") {
        if (isSchoolTeamsPage) {
          if (isSchoolTeamsPage) {
            localsearch = localsearch?.filter(
              (x) =>
                x?.type === "Team" || x?.type === "Club" || x?.type === "Group",
            );
          }

          // Remove already added orgs
          localsearch = localsearch.filter(
            (x) => !Entity?.childOrgs?.some((y: AV.ILink) => y?.id === x?.id),
          );

          // Remove already selected orgs
          localsearch = localsearch.filter(
            (x) =>
              !guardianLocalFilteredResults?.some(
                (y: AV.ILink) => y?.id === x?.id,
              ),
          );

          setGuardianLocalFilteredResults(localsearch);
        } else {
          localsearch = localsearch?.filter(
            (x) =>
              x?.type === "Team" ||
              x?.type === "Group" ||
              x?.type === "GradClass" ||
              x?.type === "PlayerOrg",
          );
          localsearch = _.uniqBy(localsearch, "id");
          setGuardianLocalFilteredResults(localsearch);
        }
      }

      setShowSearch(true);
      setSearchInput(e);
      setName(e);
    }

    if (e?.trim()?.length === 0) {
      setShowSearch(false);
    }
  };

  const searchGuardian = async (searchValue, isStaff) => {
    setSearchDone(true);
    setSearchInput(searchValue);
    setErrorMessage("");

    if (searchValue !== "" && !isTeam) {
      let searchdata = await AV.Person.search(searchValue, "Person");
      let locSearch = localUserSearch;
      if (locSearch == undefined) {
        locSearch = [];
      }
      //locSearch = locSearch.concat(searchdata);
      //locSearch = _.uniqBy(locSearch, "id");
      locSearch = _.uniqBy([...searchdata, ...(localUserSearch ?? [])], "id");
      locSearch = locSearch?.filter((x) => x?.type == "Person");
      dispatch(setSearch(locSearch));
      locSearch = locSearch?.filter(
        (x) =>
          x?.title !== undefined &&
          x?.title
            ?.toLocaleLowerCase()
            .includes(searchValue.toLocaleLowerCase()),
      );

      if (isStaff) {
        locSearch = locSearch?.filter(
          (item1) => !Entity?.staff?.some((item2) => item2?.id === item1?.id),
        );
      } else if (isMember) {
        locSearch = locSearch?.filter(
          (item1) => !Entity?.members?.some((item2) => item2?.id === item1?.id),
        );
      } else if (isParticipant) {
        locSearch = locSearch?.filter(
          (item1) =>
            !Entity?.participants?.some((item2) => item2?.id === item1?.id),
        );
      } else {
        locSearch = locSearch?.filter(
          (item1) => !Entity?.players?.some((item2) => item2?.id === item1?.id),
        );
      }
      locSearch = locSearch?.filter(
        (item1) =>
          !currentUser?.blocked?.some((item2) => item2?.id === item1?.id),
      );

      setGuardianFilteredResults(locSearch);
      setGuardianLocalFilteredResults(locSearch);
      setShowSearch(true);
      setSearchDone(false);
    } else if (isTeam) {
      let localsearch = await AV.AVEntity.search(searchValue, "Org");
      let locallySearch = localUserSearch;
      if (locallySearch == undefined) {
        locallySearch = [];
      }
      locallySearch = locallySearch.concat(localsearch);
      locallySearch = locallySearch.concat(currentUser?.orgs);
      locallySearch = _.uniqBy(locallySearch, "id");
      dispatch(setSearch(locallySearch));
      locallySearch = locallySearch?.filter((x) => x?.type !== "Person");
      locallySearch = locallySearch?.filter(
        (x) =>
          x?.title !== undefined &&
          x?.title
            ?.toLocaleLowerCase()
            .includes(searchValue.toLocaleLowerCase()),
      );

      if (searchTypes == "SubGroup" || searchTypes == "Group") {
        setGuardianLocalFilteredResults(
          locallySearch?.filter(
            (x) => x?.type === "Group" && x?.subType == undefined,
          ),
        );
      } else if (searchTypes == "Network") {
        setGuardianLocalFilteredResults(
          locallySearch?.filter(
            (x) =>
              x?.type === "Team" ||
              x?.type === "Group" ||
              x?.type === "GradClass" ||
              x?.type === "PlayerOrg",
          ),
        );
      }

      setShowSearch(true);
      setSearchInput(searchValue);
      setName(searchValue);
    } else {
      setSearchInput("");
      setGuardianFilteredResults([]);
      setGuardianLocalFilteredResults([]);
    }

    setSearchDone(false);
  };

  const handleAddTeam = async (target) => {
    setSearchInput(target?.title);
    setName(target?.title);
    setcheckvalue(false);
    setcheckvaluedata(target);
  };

  const clearValue = () => {
    setSearchInput("");
    setShowSearch(false);
    setcheckvalue(true);
    setcheckvaluedata("");
    setGuardianFilteredResults([]);
    setGuardianLocalFilteredResults([]);
  };

  const RenderalertTab: any = useCallback(
    (GuardianFilteredResults, index) => {
      let item = GuardianFilteredResults.item;
      let uri = Link.getTummb(item);
      let position = "";
      if (!uri) {
        position = "absolute";
      }

      return (
        <ScrollView
          key={index}
          showsHorizontalScrollIndicator={false}
          maxHeight={dimensions.height - 150}
        >
          <Pressable
            key={item.id}
            padding={"10px"}
            _hover={{ bgColor: "AVColor.secondary" }}
            onPress={() => {
              handleAddTeam(item);
              setShowSearch(false);
              setSearchInput("");
            }}
          >
            <Box>
              <HStack alignItems="center" space={3}>
                <Box
                  h="50px"
                  w="50px"
                  borderRadius="full"
                  overflow="hidden"
                  flexShrink={0}
                >
                  <EntityProfilePic width={50} height={50} link={item} />
                </Box>

                <VStack justifyContent="center" flex={1} minW={0}>
                  <Text
                    fontWeight="bold"
                    numberOfLines={1}
                    ellipsizeMode="tail"
                    fontSize="15px"
                  >
                    {item.title}
                  </Text>

                  {item.data && item.type !== "Channel" && (
                    <Text
                      fontSize="12px"
                      color="gray.500"
                      numberOfLines={1}
                      mt={0.5}
                    >
                      {item.data}
                    </Text>
                  )}
                </VStack>
              </HStack>
            </Box>
          </Pressable>
        </ScrollView>
      );
    },
    [GuardianFilteredResults],
  );

  useEffect(() => {
    const loadData = async () => {
      // Set Role
      if (Entity?.roles?.[0]) {
        setRole(Entity.roles[0].name);
      }

      // Helper to get parent entity
      const getParentEntity = async () => {
        if (!Entity?.parent) return null;

        let parentEntity = entitydatalist?.find(
          (x) => x?.id === Entity.parent?.id,
        );

        if (!parentEntity) {
          parentEntity = await AV.AVEntity.get(Entity.parent);
          if (parentEntity) {
            dispatch(setEntitydata([...(entitydatalist ?? []), parentEntity]));
          }
        }

        return parentEntity;
      };

      // PlayerOrg && Class, SchoolYear
      if (
        Entity?.type === "PlayerOrg" &&
        Entity?.subType === "Class" &&
        Entity?.parent?.type === "SchoolYear"
      ) {
        const parentEntity = await getParentEntity();

        if (parentEntity) {
          setSearchYearStudents(true);
          setSchoolYearStudents(parentEntity.players ?? []);
        }
      }

      // Collect, Parent members
      if (Entity?.type === "Collect") {
        const parentEntity = await getParentEntity();

        if (parentEntity) {
          setSearchCollectMembers(true);
          const members = [
            ...(parentEntity.members ?? []),
            ...(parentEntity.players ?? []),
            ...(parentEntity.participants ?? []),
          ];
          setCollectEntityMembers(members);
          setCollectEntityStaffs(parentEntity?.staff);
        }
      }
    };

    loadData();
  }, [showAddProfileModal]);

  const defaultButtonDisabled = checkvalue
    ? !name.trim() ||
      !emailAddress.trim() ||
      !emailRegex.test(emailAddress.trim())
    : !name;
  const buttonDisabledStaff = checkvalue
    ? !name.trim() ||
      !emailAddress.trim() ||
      !emailRegex.test(emailAddress.trim())
    : !Role;
  //!name || !Role

  return (
    <Box
      position="fixed"
      bgColor={"AVColor.overlay2"}
      bottom={0}
      right={0}
      top={0}
      left={0}
    >
      <div
        style={{
          position: "fixed",
          top: "53%",
          left: "50%",
          transform: "translate(-53%, -50%)",
          background: "#ffffff",
          boxShadow:
            "0 12px 28px 0 rgba(0, 0, 0, 0.2), 0 2px 4px 0 rgba(0, 0, 0, 0.1), inset 0 0 0 1px rgba(255, 255, 255, 0.5)",
          width: isMobile ? "88%" : "68%",
          borderRadius: "8px",
          height: "75%",
          overflowY: "auto",
        }}
      >
        <VStack flex={1} width={"100%"}>
          <HStack
            alignItems={"center"}
            justifyContent={"space-between"}
            borderBottomColor={"AVColor.grey"}
            px={5}
            zIndex={99}
            width={"100%"}
          >
            <Text fontSize={24}>
              {!isMember &&
              isTeam &&
              Entity?.type === "PlayerOrg" &&
              Entity?.subType === "Class"
                ? Loc.currentLang.menu?.addorganization
                : isSchoolTeamsPage
                  ? `${Loc.currentLang.menu?.add} ${Loc.currentLang.menu?.teams}`
                  : !isPlayer &&
                      isMember &&
                      Entity?.type === "PlayerOrg" &&
                      (Entity?.subType == "Class" || Entity?.subType === "Term")
                    ? Loc.currentLang.menu?.addParents
                    : !isPlayer &&
                        isMember &&
                        Entity?.type === "PlayerOrg" &&
                        Entity?.parent?.type === "Team" &&
                        Entity?.subType === undefined
                      ? Loc.currentLang.menu?.addParents
                      : isMember && Entity?.subType === "GradClass"
                        ? Loc.currentLang.menu?.addParents
                        : isStaff &&
                            Entity?.type === "PlayerOrg" &&
                            Entity?.subType === "Class"
                          ? Loc.currentLang.menu.addStaff
                          : isMember && Entity?.type === "Organization"
                            ? "Add Employees"
                            : Entity?.subType === "Class" && isMember
                              ? Loc.currentLang.menu?.addParents
                              : isMember &&
                                  Entity?.type !== "Neighborhood" &&
                                  Entity?.type !== "School"
                                ? Loc.currentLang.menu.addMember
                                : isPlayer &&
                                    !isMember &&
                                    !isStaff &&
                                    Entity?.subType !== "Class" &&
                                    Entity?.subType !== "GradClass" &&
                                    Entity?.subType !== "Term" &&
                                    Entity?.type !== "SchoolYear"
                                  ? Loc.currentLang.menu.addPlayers
                                  : Entity?.subType === "Term" && isPlayer
                                    ? Loc.currentLang.menu.addMember
                                    : isPlayer &&
                                        !isMember &&
                                        !isStaff &&
                                        (Entity?.subType === "Class" ||
                                          Entity?.subType === "GradClass" ||
                                          Entity?.type === "SchoolYear")
                                      ? Loc.currentLang.menu.addStudents
                                      : !isMember &&
                                          !isPlayer &&
                                          isTeam &&
                                          Entity?.type === "Group" &&
                                          Entity?.subType === undefined &&
                                          !isStaff
                                        ? "Add organization"
                                        : Entity?.subType === "Term" && isStaff
                                          ? "Add Directors"
                                          : Entity?.subType === "Term"
                                            ? Loc.currentLang.menu
                                                ?.addorganization
                                            : isStaff &&
                                                Entity?.type === "Neighborhood"
                                              ? Loc.currentLang.menu.addStaff
                                              : isMember &&
                                                  Entity?.type ===
                                                    "Neighborhood"
                                                ? "Add Neighbors"
                                                : (Entity?.type === "Club" ||
                                                      Entity?.type ===
                                                        "LeagueSeason") &&
                                                    isTeam
                                                  ? Loc.currentLang.menu.teams
                                                  : isTeam
                                                    ? Loc.currentLang.menu
                                                        ?.addorganization
                                                    : isParticipant
                                                      ? Loc.currentLang.menu
                                                          .addParticipants
                                                      : Entity?.type ===
                                                            "School" && isStaff
                                                        ? "Add Administration"
                                                        : Entity?.type ===
                                                              "School" &&
                                                            isMember
                                                          ? "Add Staff"
                                                          : Loc.currentLang.menu
                                                              .addStaff}
            </Text>

            <HStack>
              <HStack height={"30px"}>
                <AVCancel
                  callback={(e) => {
                    e?.stopPropagation?.();
                    setShowSearch(false);
                    setShowAddProfileModal(false);
                  }}
                  //callback={() => setShowAddProfileModal(false)}
                  color={undefined}
                  size={undefined}
                />
              </HStack>
            </HStack>
          </HStack>

          <Divider zIndex={-1} marginY={3} />
          {/* if teams */}
          {(isStaff || isMember || isPlayer || isParticipant) && !isTeam && (
            <>
              <HStack
                alignItems={"center"}
                justifyContent={checkvalue ? "space-between" : "flex-start"}
                borderBottomColor={"AVColor.grey"}
                px={5}
                zIndex={99}
                width={"100%"}
                space={3}
                flexWrap={"wrap"}
              >
                {/*Name*/}
                <Box
                  ref={menuRefs}
                  marginBottom={"10px"}
                  width={isMobile ? "100%" : !isStaff ? "25%" : "20%"}
                >
                  <AVInputtext
                    type={"text"}
                    label={Loc.currentLang.menu.nameReq}
                    onChange={(e) => handlesearchTeams(e?.target?.value)}
                    value={name}
                    height={"15px"}
                    width={undefined}
                    maxLength={50}
                    defaultValue={undefined}
                    minRows={undefined}
                    multiline={undefined}
                    size={undefined}
                    placeholder={undefined}
                  />
                </Box>

                {/*Email&Phone*/}
                {checkvalue && (
                  <>
                    <Box
                      marginBottom={"10px"}
                      width={isMobile ? "100%" : !isStaff ? "25%" : "20%"}
                    >
                      <AVInputtext
                        type={"text"}
                        label={Loc.currentLang.menu.emailAddress}
                        onChange={HandleEmailAddress}
                        value={emailAddress}
                        height={"15px"}
                        width={undefined}
                        maxLength={50}
                        defaultValue={undefined}
                        minRows={undefined}
                        multiline={undefined}
                        size={undefined}
                        placeholder={undefined}
                      />
                    </Box>

                    <Box
                      marginBottom={"10px"}
                      width={isMobile ? "100%" : !isStaff ? "25%" : "20%"}
                    >
                      <AVInputtext
                        type={"text"}
                        label={Loc.currentLang.menu.phone}
                        onChange={HandlePhone}
                        value={phone}
                        height={"15px"}
                        width={undefined}
                        maxLength={50}
                        defaultValue={undefined}
                        minRows={undefined}
                        multiline={undefined}
                        size={undefined}
                        placeholder={undefined}
                      />
                    </Box>
                  </>
                )}

                {/*Role Dropdown*/}
                {!isMember && !isPlayer && !isParticipant && (
                  <Box marginBottom={"9px"} width={isMobile ? "100%" : "20%"}>
                    <FormControl fullWidth>
                      <InputLabel id="demo-simple-select-label">
                        {Loc.currentLang.menu.assignRole} *
                      </InputLabel>

                      <Select
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        value={Role}
                        label={Loc.currentLang.menu.assignRole}
                        onChange={(e) => setRole(e.target.value)}
                        style={
                          isMobile ? customSelectStyle : customSelectStyleeee
                        }
                      >
                        {Entity?.roles?.map((option) => (
                          <MenuItem key={option?.name} value={option?.name}>
                            {option?.name}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Box>
                )}

                {/*Searched value*/}
                {!checkvalue && (
                  <Box
                    p={1}
                    backgroundColor={"AVColor.hovercolor2"}
                    borderRadius={"full"}
                  >
                    <HStack
                      alignItems={"center"}
                      justifyContent={"center"}
                      space={2}
                      px={2}
                    >
                      <EntityProfilePic
                        width={50}
                        height={50}
                        link={checkvaluedata}
                      />

                      <VStack>
                        <Text
                          minW={"0"}
                          maxW={"200px"}
                          text-overflow={"ellipsis"}
                          numberOfLines={1}
                          fontWeight="bold"
                        >
                          {checkvaluedata.title}
                        </Text>
                      </VStack>
                    </HStack>
                  </Box>
                )}

                {/*To Add*/}
                <VStack>
                  <HStack space={5}>
                    <Button
                      bgColor={"AVColor.primary"}
                      borderRadius={"full"}
                      padding={2}
                      isDisabled={
                        isMember
                          ? defaultButtonDisabled
                          : isStaff
                            ? buttonDisabledStaff
                            : isPlayer
                              ? !name.trim() ||
                                (!emailAddress.trim() &&
                                  (!Parentname.trim() ||
                                    !ParentemailAddress.trim()) &&
                                  checkvalue)
                              : isParticipant
                                ? defaultButtonDisabled
                                : !name
                      }
                      isLoading={isLoader}
                      onPress={() =>
                        handleAddProfile(
                          isMember
                            ? "Member"
                            : isPlayer && !isMember
                              ? "Player"
                              : isParticipant
                                ? "Participant"
                                : "Staff",
                        )
                      }
                    >
                      <AddIcon size={"20px"} color="AVColor.white" />
                    </Button>

                    {!checkvalue && (
                      <Button
                        alignSelf={isMobile ? "center" : ""}
                        _hover={{ bgColor: "AVColor.grey", borderRadius: "sm" }}
                        rounded={"full"}
                        bgColor={"gray.100"}
                        borderRadius={"full"}
                        padding={2}
                        onPress={() => {
                          setcheckvalue(true);
                          setcheckvaluedata("");
                          setName("");
                          setErrorMessage("");
                        }}
                      >
                        <CloseIcon size={"20px"} color="black" />
                      </Button>
                    )}
                  </HStack>
                </VStack>
              </HStack>
            </>
          )}

          {isTeam && !isMember && !isPlayer && !isParticipant && !isStaff && (
            //  <TeamSearch orgFK={ orgFK }  { ...props } />
            <VStack justifyContent={"center"}>
              <HStack alignItems={"center"} justifyContent={"center"}>
                <Input
                  placeholder={Loc.currentLang.menu.search}
                  placeholderTextColor="gray.500"
                  top={"0px"}
                  ml={"2px"}
                  rounded="full"
                  variant="AVSearchInput"
                  width="290px"
                  height="40px"
                  fontSize={"16px"}
                  borderRadius="10"
                  p={2}
                  backgroundColor={"#EEEEEE"}
                  borderColor={"gray.200"}
                  InputLeftElement={
                    <SearchIcon
                      ml="2"
                      size="24px"
                      color="black"
                      left={"2px"}
                      marginRight={"10px"}
                      alignSelf={"center"}
                    />
                  }
                  value={searchInput}
                  onChangeText={(e) => handlesearchTeams(e)}
                />

                {!checkvalue && (
                  <HStack position={"absolute"} right={"40px"}>
                    <Box borderRadius={"full"} right={"40px"}>
                      <HStack
                        alignItems={"center"}
                        justifyContent={"center"}
                        space={2}
                      >
                        <EntityProfilePic
                          width={50}
                          height={50}
                          link={checkvaluedata}
                        />

                        <VStack>
                          <Text
                            minW={"0"}
                            maxW={"130px"}
                            text-overflow={"ellipsis"}
                            numberOfLines={1}
                            fontWeight="bold"
                          >
                            {checkvaluedata.title}
                          </Text>
                          {/*<Text fontSize={'12px'}>{checkvaluedata.blurb}</Text>*/}
                        </VStack>
                      </HStack>
                    </Box>

                    <HStack space={2}>
                      <Button
                        bgColor={"AVColor.primary"}
                        borderRadius={"full"}
                        right={"25px"}
                        height={"35px"}
                        top={"10px"}
                        padding={2}
                        isLoading={isLoader}
                        isDisabled={checkvalue}
                        onPress={() => handleAddTeamProfile()}
                      >
                        <AddIcon size={"20px"} color="AVColor.white" />
                      </Button>

                      {!checkvalue && (
                        <Button
                          bgColor={"grey.200"}
                          borderRadius={"full"}
                          right={"25px"}
                          height={"35px"}
                          top={"10px"}
                          padding={2}
                          onPress={() => {
                            setcheckvalue(true);
                            setcheckvaluedata("");
                            setName("");
                          }}
                        >
                          <CloseIcon size={"18px"} color="black" />
                        </Button>
                      )}
                    </HStack>
                  </HStack>
                )}
              </HStack>

              <HStack justifyContent={"center"}>
                {showSearch && isTeam && (
                  <>
                    <Box
                      ref={menuRefs}
                      background={"#ffffff"}
                      borderRadius="md"
                      shadow="9"
                      position="absolute"
                      top={"10px"}
                      height={"auto"}
                      maxHeight={"250px"}
                      width={"280px"}
                      zIndex={999999}
                    >
                      {guardianLocalFilteredResults?.length !== 0 ? (
                        <VStack zIndex={999999}>
                          <HStack
                            space={2}
                            bgColor={"AVColor.white"}
                            zIndex={999999}
                          >
                            <HStack>
                              <Text color={"#818181"} fontWeight={"bold"}>
                                {Loc.currentLang.menu.suggestions}
                              </Text>
                              <Pressable onPress={() => clearValue()}>
                                <HStack
                                  justifyContent={"flex-end"}
                                  left={"150px"}
                                >
                                  <CrossIcon
                                    size="32px"
                                    color="#000000"
                                    alignSelf={"center"}
                                  />
                                </HStack>
                              </Pressable>
                            </HStack>
                          </HStack>
                        </VStack>
                      ) : (
                        <HStack alignSelf={"center"}>
                          <Text variant={"AVSearchTitleText"}>
                            {Loc.currentLang.menu.noRecordsFound}
                          </Text>
                        </HStack>
                      )}

                      <FlatList
                        removeClippedSubviews={false}
                        scrollEnabled={true}
                        disableVirtualization={true}
                        data={guardianLocalFilteredResults}
                        renderItem={RenderalertTab}
                        // renderItem={(item, index) => <RenderalertTab {...item} key={index} />}
                        initialNumToRender={5}
                        maxToRenderPerBatch={5}
                        windowSize={3}
                        onEndReachedThreshold={0.1}
                        keyExtractor={(item: any) => item?.id}
                      />

                      {isSearchDone && (
                        <VStack>
                          <VStack
                            ref={menuRefs}
                            space={2}
                            borderRadius="md"
                            shadow="9"
                            width={"275px"}
                            m={1}
                            p={2.5}
                            mt={"4px"}
                            bgColor={"#ffffff"}
                            zIndex={999}
                            position={"fixed"}
                          >
                            <Pressable
                              onPress={() =>
                                searchGuardian(searchInput, isStaff)
                              }
                            >
                              <HStack space={10}>
                                <SearchIcon
                                  size={"AVIconSmall"}
                                  color={"#18B0C2"}
                                />
                                <Text fontWeight={"bold"} color={"#18B0C2"}>
                                  Search
                                </Text>
                              </HStack>
                            </Pressable>
                          </VStack>
                        </VStack>
                      )}
                    </Box>
                  </>
                )}
              </HStack>

              {isTeam && Entity.type === "LeagueSeason" && (
                <Box mt={40} zIndex={showSearch ? "-3" : "unset"}>
                  {/* Divider */}
                  <HStack alignItems="center" mb={4}>
                    <Box flex={1} height="1px" bg="gray.300" />
                    <Text mx={3} color="gray.500" fontSize="14px">
                      Or Invite
                    </Text>
                    <Box flex={1} height="1px" bg="gray.300" />
                  </HStack>

                  {/* Social Icons */}
                  <HStack justifyContent="center">
                    <div ref={socialInviteRef}>
                      <SocialShare />
                    </div>
                  </HStack>
                </Box>
              )}
            </VStack>
          )}

          {showSearch && !isTeam && (
            <>
              <Box
                ref={menuRefs}
                background={"#ffffff"}
                position={"absolute"}
                borderRadius="md"
                shadow="9"
                left={isTeam ? "360px" : "15px"}
                top={"115px"}
                height={"auto"}
                maxHeight={"250px"}
                width={"280px"}
                zIndex={999999}
              >
                {guardianLocalFilteredResults?.length !== 0 ? (
                  <VStack zIndex={999999}>
                    <HStack space={2} bgColor={"AVColor.white"} zIndex={999999}>
                      <HStack>
                        <Text color={"#818181"} fontWeight={"bold"}>
                          {Loc.currentLang.menu.suggestions}
                        </Text>
                        <Pressable onPress={() => clearValue()}>
                          <HStack justifyContent={"flex-end"} left={"150px"}>
                            <CrossIcon
                              size="32px"
                              color="#000000"
                              alignSelf={"center"}
                            />
                          </HStack>
                        </Pressable>
                      </HStack>
                    </HStack>
                  </VStack>
                ) : (
                  <HStack alignSelf={"center"}>
                    <Text variant={"AVSearchTitleText"}>
                      {Loc.currentLang.menu.noRecordsFound}
                    </Text>
                  </HStack>
                )}

                <FlatList
                  removeClippedSubviews={false}
                  scrollEnabled={true}
                  disableVirtualization={true}
                  data={guardianLocalFilteredResults}
                  renderItem={RenderalertTab}
                  // renderItem={(item, index) => <RenderalertTab {...item} key={index} />}
                  initialNumToRender={5}
                  maxToRenderPerBatch={5}
                  windowSize={3}
                  onEndReachedThreshold={0.1}
                  keyExtractor={(item: any) => item?.id}
                />

                <VStack>
                  <VStack
                    ref={menuRefs}
                    space={2}
                    borderRadius="md"
                    shadow="9"
                    width={"275px"}
                    m={1}
                    p={2.5}
                    mt={"4px"}
                    bgColor={"#ffffff"}
                    zIndex={999}
                    position={"fixed"}
                  >
                    <Pressable
                      onPress={() => searchGuardian(searchInput, isStaff)}
                    >
                      <HStack space={10}>
                        <SearchIcon size={"AVIconSmall"} color={"#18B0C2"} />
                        <Text fontWeight={"bold"} color={"#18B0C2"}>
                          Search
                        </Text>
                      </HStack>
                    </Pressable>
                  </VStack>
                </VStack>
              </Box>
            </>
          )}

          {isPlayer && !isTeam && (
            <HStack
              alignItems={"center"}
              justifyContent={checkvalue ? "space-between" : "flex-start"}
              borderBottomColor={"AVColor.grey"}
              px={5}
              zIndex={-3}
              width={"100%"}
              space={3}
              flexWrap={"wrap"}
            >
              {/*Name*/}
              <Box
                width={isMobile ? "245px" : "25%"}
                ref={menuRefs}
                marginBottom={"10px"}
              >
                {checkvalue && (
                  <AVInputtext
                    type={"text"}
                    label={Loc.currentLang.menu.parentName}
                    onChange={(e) => setParentName(e?.target?.value)}
                    value={Parentname}
                    height={"15px"}
                    width={undefined}
                    maxLength={50}
                    defaultValue={undefined}
                    minRows={undefined}
                    multiline={undefined}
                    size={undefined}
                    placeholder={undefined}
                  />
                )}
              </Box>

              {/*Email&Phone*/}
              {checkvalue && (
                <>
                  <Box marginBottom={"10px"} width={isMobile ? "245px" : "25%"}>
                    <AVInputtext
                      type={"text"}
                      label={Loc.currentLang.menu.parentEmailAddress}
                      onChange={(e) =>
                        setIsParentEmailaddress(e?.target?.value)
                      }
                      value={ParentemailAddress}
                      height={"15px"}
                      width={undefined}
                      maxLength={50}
                      defaultValue={undefined}
                      minRows={undefined}
                      multiline={undefined}
                      size={undefined}
                      placeholder={undefined}
                    />
                  </Box>

                  <Box marginBottom={"10px"} width={isMobile ? "245px" : "25%"}>
                    <AVInputtext
                      type={"text"}
                      label={Loc.currentLang.menu.parentPhone}
                      onChange={HandleParentPhone}
                      value={Parentphone}
                      height={"15px"}
                      width={undefined}
                      maxLength={50}
                      defaultValue={undefined}
                      minRows={undefined}
                      multiline={undefined}
                      size={undefined}
                      placeholder={undefined}
                    />
                  </Box>
                </>
              )}

              {/*To Add*/}
              <VStack bgColor={"white"} borderRadius={"full"} padding={2}>
                <HStack height={"20px"} width={"20px"}></HStack>
              </VStack>
            </HStack>
          )}

          {errorMessage && (
            <HStack justifyContent={"center"}>
              <Text color={"red.500"} fontSize={"16px"} fontWeight={400}>
                {errorMessage}
              </Text>
            </HStack>
          )}

          {/*Created CARD*/}
          {!isTeam && (
            <ScrollView
              showsHorizontalScrollIndicator={false}
              nestedScrollEnabled={true}
              zIndex={-3}
            >
              <HStack width="100%" height="auto" zIndex="9999">
                {filteredResults.length > 0 && !isMobile && (
                  <Box
                    width={"23%"}
                    position="absolute"
                    maxHeight="230px"
                    minHeight="43px"
                    backgroundColor={"#f2f2f2"}
                    background={"#0000"}
                    borderColor={"AVColor.hovercolor2"}
                    shadow="2"
                    left={4}
                    borderRadius="8px"
                    overflowY="scroll"
                  >
                    <Box bgColor={["AVColor.white"]}>
                      <ScrollView
                        showsHorizontalScrollIndicator={false}
                        maxHeight={"200px"}
                      >
                        <VStack space={3}>
                          {filteredResults.map((item: any) => (
                            <label
                              key={item.id}
                              onClick={(e) => handleStaffName(item)}
                            >
                              <HStack
                                space={2}
                                alignItems="center"
                                px={3}
                                py={3}
                              >
                                <EntityProfilePic
                                  width={50}
                                  height={50}
                                  link={item}
                                />

                                <VStack>
                                  <Text fontWeight="bold">{item.title}</Text>
                                </VStack>
                              </HStack>
                            </label>
                          ))}
                        </VStack>
                      </ScrollView>
                    </Box>
                  </Box>
                )}
              </HStack>

              <View
                flexDir={"row"}
                marginTop={"10px"}
                zIndex={-3}
                alignItems={"center"}
              >
                <View
                  flex={1}
                  height={"1px"}
                  zIndex={-3}
                  backgroundColor={"#D3D3D3"}
                />
                <View>
                  <Text style={{ width: 50, textAlign: "center" }}>
                    {Loc.currentLang.menu.or}
                  </Text>
                </View>
                <View
                  flex={1}
                  height={"1px"}
                  zIndex={-3}
                  backgroundColor={"#D3D3D3"}
                />
              </View>

              <VStack
                borderStyle={"dashed"}
                borderColor={"gray.300"}
                borderRadius={"5px"}
                borderWidth={"1px"}
                padding={"20px"}
                width={"80%"}
                alignSelf={"center"}
                zIndex={-3}
                marginTop={"10px"}
              >
                <div
                  style={{ textAlign: "center" }}
                  onDrop={handleDrop}
                  onDragOver={handleDragOver}
                >
                  <HStack justifyContent={"center"} space={2}>
                    <Pressable onPress={() => imageInputRef?.current?.click()}>
                      <HStack space={2}>
                        <Text color={"#00A7BC"}>
                          {Loc.currentLang.menu.uploadFile}{" "}
                        </Text>
                        <Text color={"black"} fontWeight={500}>
                          {Loc.currentLang.menu.or}
                        </Text>
                        <Text color={"black"}>
                          {Loc.currentLang.menu.dragNDrop}
                        </Text>
                      </HStack>
                    </Pressable>
                  </HStack>
                  <Text textAlign={"center"} color={"gray.300"}>
                    ({Loc.currentLang.menu.docExtensions})
                  </Text>

                  {error && (
                    <Text
                      textAlign={"center"}
                      color={"#DF2827"}
                      marginTop={"5px"}
                    >
                      {" "}
                      {error}
                    </Text>
                  )}
                </div>
              </VStack>

              {(isStaff || isMember || isPlayer) && (
                <HStack justifyContent={"center"} top={"50px"}>
                  <div ref={socialInviteRef}>
                    <SocialShare />
                  </div>
                </HStack>
              )}
              <HStack
                width={isLMobile ? "95%" : isLMobile ? "95%" : "95%"}
                margin-right={"5px"}
                textAlign={"justify"}
                marginTop={isMobile ? "15%" : isLMobile ? "15%" : "10%"}
              >
                <img
                  src={inform}
                  style={{
                    width: "20px",
                    height: "20px",
                    padding: "10px",
                    marginTop: "-10px",
                  }}
                />
                {isStaff
                  ? Loc.currentLang.helpText.addStaff
                  : isMember
                    ? Loc.currentLang.helpText.addMember
                    : isPlayer &&
                        !isMember &&
                        !isStaff &&
                        isPlayer &&
                        (Entity?.subType == "Class" ||
                          Entity?.subType == "GradClass")
                      ? Loc.currentLang.helpText.addStudent
                      : isPlayer
                        ? Loc.currentLang.helpText.addPlayer
                        : Loc.currentLang.helpText.addPlayer}
              </HStack>

              <input
                type="file"
                accept=".txt,.docx,.xlsx,.ods,.odt,.csv"
                multiple
                hidden
                ref={imageInputRef}
                onChange={handlefileUpload}
              />

              {
                <HStack
                  flexWrap={"wrap"}
                  alignSelf={"flex-start"}
                  zIndex={-3}
                  height={"300px"}
                  overflowY={"auto"}
                >
                  {showTempList?.map((item: any) => (
                    <Box
                      key={item.id}
                      bgColor={"#fff"}
                      borderWidth={"1px"}
                      borderColor={"#e7ebe5"}
                      margin={4}
                      overflow="hiden"
                      minWidth={130}
                      height={"150px"}
                      rounded="lg"
                      zIndex={-3}
                    >
                      <VStack alignItems={"center"} padding={2} zIndex={-3}>
                        <Pressable
                          key={item.id}
                          zIndex={-3}
                          _hover={{ bgColor: "#EEEEEE" }}
                          onPress={() => {
                            navigate(`/profile/${item?.id}/${item?.region}`, {
                              state: {
                                user: {
                                  id: item?.id,
                                  pk: item?.pk,
                                  region: item?.region,
                                  type: item?.type,
                                  name: item?.title,
                                },
                              },
                            });
                          }}
                        >
                          {item?.thumb && (
                            <Box
                              bgColor={"#FF6600"}
                              borderRadius={["full"]}
                              width={"70px"}
                              height={"70px"}
                              left={"20px"}
                              p={0}
                              zIndex={-3}
                            >
                              <Image
                                style={{
                                  height: "100%",
                                  width: "100%",
                                  borderRadius: 100,
                                }}
                                source={{
                                  uri: AV.Media.getThumb(item),
                                }}
                              />
                            </Box>
                          )}

                          {!item?.thumb && (
                            <Box alignItems={"center"}>
                              <Profile
                                height={"70"}
                                width={"70"}
                                color={"#32AE78"}
                              />
                            </Box>
                          )}

                          <Pressable
                            zIndex={-3}
                            onPress={() => {
                              navigate(`/profile/${item?.id}/${item?.region}`, {
                                state: {
                                  user: {
                                    id: item?.id,
                                    pk: item?.pk,
                                    region: item?.region,
                                    type: item?.type,
                                    name: item?.title,
                                  },
                                },
                              });
                            }}
                          >
                            <Text
                              marginTop={2}
                              left={"2px"}
                              alignItems="center"
                              width="120px"
                              numberOfLines={1}
                              textAlign="center"
                              zIndex={-3}
                            >
                              {item.title}
                            </Text>
                          </Pressable>

                          <Text
                            marginTop={2}
                            left={"2px"}
                            alignItems="center"
                            width="120px"
                            numberOfLines={1}
                            textAlign="center"
                            zIndex={-3}
                          >
                            {item?.role?.name}
                          </Text>
                        </Pressable>
                      </VStack>
                    </Box>
                  ))}
                </HStack>
              }
            </ScrollView>
          )}
        </VStack>
      </div>
    </Box>
  );
};

export default AVPersonaModal;
